import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './Politici.css';

export default function Confidentialitate() {
    return (
        <Container className="politiciContainer worldwide">
            <p className="politiciTitle">
                <span className="bracket">{'<'}</span>
                    Politica de Confidențialitate
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="politiciSubTitle">Află cum îți protejăm datele personale</p>
            <Row>
                <div className="politiciText">
                    <p>
                        Această Politică de Confidențialitate explică modul în care <strong>CRANTEA ANTONIO-CRISTIAN PERSOANĂ FIZICĂ AUTORIZATĂ</strong>,
                        cu sediul în <strong>București, România</strong>, procesează datele personale ale utilizatorilor
                        site-ului <strong>info-cu-toni.ro</strong>.
                    </p>

                    <h4>1. Ce date colectăm</h4>
                    <p>Putem colecta următoarele date:</p>
                    <ul>
                        <li>Nume și prenume</li>
                        <li>Adresă de email</li>
                        <li>Număr de telefon</li>
                        <li>Date de facturare (dacă se achiziționează servicii)</li>
                        <li>Mesaje trimise prin formulare</li>
                        <li>Adresa IP, date tehnice, browser, device</li>
                        <li>Cookies și date de analiză</li>
                    </ul>

                    <h4>2. Cum colectăm datele</h4>
                    <p>Datele sunt colectate prin:</p>
                    <ul>
                        <li>formulare de contact</li>
                        <li>formulare de programare</li>
                        <li>cookies și tehnologii similare</li>
                    </ul>

                    <h4>3. Scopul colectării</h4>
                    <p>Folosim datele pentru:</p>
                    <ul>
                        <li>oferirea serviciilor de meditații</li>
                        <li>contactarea utilizatorilor și programarea ședințelor</li>
                        <li>emiterea facturilor</li>
                        <li>îmbunătățirea experienței pe site</li>
                        <li>statistici și analiză (Google Analytics)</li>
                    </ul>

                    <h4>4. Temeiul legal</h4>
                    <p>
                        Datele sunt prelucrate în baza:
                        <ul>
                            <li>consimțământului</li>
                            <li>executării unui contract</li>
                            <li>obligațiilor legale</li>
                            <li>interesului legitim</li>
                        </ul>
                    </p>

                    <h4>5. Cine are acces la date</h4>
                    <p>Datele pot fi partajate cu:</p>
                    <ul>
                        <li>furnizori de găzduire</li>
                        <li>procesatori de plăți (ex: Revolut)</li>
                        <li>Google Analytics</li>
                        <li>Meta / Facebook pentru marketing (dacă este cazul)</li>
                    </ul>
                    <p><strong>Nu vindem date personale.</strong></p>

                    <h4>6. Durata de stocare</h4>
                    <p>Datele sunt păstrate atât timp cât este necesar pentru:</p>
                    <ul>
                        <li>prestarea serviciilor</li>
                        <li>obligații contabile / fiscale</li>
                    </ul>

                    <h4>7. Drepturile utilizatorului</h4>
                    <p>Ai dreptul de:</p>
                    <ul>
                        <li>acces la datele tale</li>
                        <li>rectificare</li>
                        <li>ștergere</li>
                        <li>restricționare</li>
                        <li>portabilitate</li>
                        <li>opoziție la prelucrare</li>
                        <li>retragerea consimțământului</li>
                    </ul>
                    <p>Pentru exercitarea drepturilor: <strong>antoniocrantea@gmail.com</strong></p>

                    <h4>8. Securitatea datelor</h4>
                    <p>
                        Implementăm măsuri tehnice și organizaționale pentru protejarea datelor,
                        inclusiv criptare, acces securizat și backup.
                    </p>

                    <h4>9. Cookies</h4>
                    <p>
                        Site-ul folosește cookies pentru funcționare, statistici și marketing.
                        Poți afla mai multe în Politica de Cookies.
                    </p>

                    <h4>10. Contact</h4>
                    <p>
                        Pentru întrebări legate de datele personale ne poți contacta la:
                        <br/>
                        <strong>antoniocrantea@gmail.com</strong>
                    </p>
                </div>
            </Row>
        </Container>
    );
}